import React from "react";
import { Link as RouterLink } from "react-router-dom";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";

const AuthCredit = () => (
  <Typography variant="body2" align="center" style={{ color: "#64748b", fontSize: 13 }}>
    Desarrollado por{" "}
    <span style={{ color: "#0f172a", fontWeight: 700 }}>StreamDIGI</span>
    <br />
    <Link component={RouterLink} to="/privacidad" style={{ color: "#2563eb", fontWeight: 600 }}>
      Privacidad
    </Link>
  </Typography>
);

export default AuthCredit;
